import styled from 'styled-components';

export const EdiRfidAuditRequestExecutionListContainerStyle = styled.div`
  .generated-list__table-wrapper {
    min-height: unset !important;
  }
`;
